export default "__VITE_ASSET__gRR6ErEY__"